var _this = this,
    _jsxFileName = "/builds/zillow/adtech-product/constellation/zrs-cms-messaging/src/img/ComparableHome.jsx";

import React from 'react';
import PropTypes from 'prop-types';

var ComparableHome = function ComparableHome(_ref) {
  var className = _ref.className;
  return /*#__PURE__*/React.createElement("svg", {
    width: "39",
    height: "40",
    viewBox: "0 0 39 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: className,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 5,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 13,
      columnNumber: 9
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.1145 15.3231C17.6248 14.8607 16.9767 14.6031 16.3031 14.6031C15.6294 14.6031 14.9813 14.8607 14.4916 15.3231L5.96293 23.3846C5.69936 23.6296 5.48942 23.9265 5.34635 24.2566C5.20327 24.5867 5.13016 24.9428 5.13161 25.3026V37.3949C5.13161 38.094 5.40952 38.7644 5.90417 39.2587C6.39882 39.7531 7.06971 40.0308 7.76925 40.0308H24.9395C25.6373 40.0281 26.3055 39.7491 26.7979 39.2551C27.2904 38.7611 27.5669 38.0922 27.5669 37.3949V25.3128C27.5664 24.9524 27.4914 24.596 27.3465 24.266C27.2017 23.9359 26.9902 23.6394 26.7253 23.3949L18.1145 15.3231Z",
    fill: "#A6E5FF",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 14,
      columnNumber: 13
    }
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.36002 12.2564C9.84968 11.7941 10.4978 11.5365 11.1715 11.5365C11.8451 11.5365 12.4932 11.7941 12.9829 12.2564L21.5937 20.3282C21.8586 20.5727 22.0701 20.8693 22.215 21.1993C22.3598 21.5294 22.4348 21.8858 22.4353 22.2462V34.318C22.4272 35.0099 22.1471 35.671 21.6556 36.1584C21.164 36.6458 20.5004 36.9205 19.8079 36.9231H2.63766C1.94342 36.9231 1.27713 36.6497 0.783351 36.162C0.289575 35.6743 0.0081251 35.0117 2.11181e-05 34.318V22.2359C-0.00142764 21.8762 0.0716805 21.5201 0.214756 21.19C0.357831 20.8599 0.56777 20.563 0.831334 20.318L9.36002 12.2564ZM2.63766 34.318H19.8079V22.2359L11.1868 14.1744L2.64793 22.2359L2.63766 34.318Z",
    fill: "#0D4599",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 18,
      columnNumber: 13
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.49211 25.4359C7.33418 25.2769 7.13788 25.1612 6.92214 25.1001C6.70639 25.039 6.47848 25.0346 6.26052 25.0872C6.03352 25.1442 5.82589 25.2606 5.65904 25.4247C5.49219 25.5887 5.3722 25.7942 5.3115 26.0201C5.25081 26.246 5.25162 26.484 5.31382 26.7095C5.37602 26.9349 5.4973 27.1397 5.66524 27.3026L8.30288 29.9385C8.55433 30.1795 8.88849 30.3152 9.23686 30.318C9.53524 30.3182 9.82479 30.217 10.0579 30.0308L16.6571 24.759C16.7919 24.6513 16.9041 24.518 16.9874 24.367C17.0706 24.2159 17.1233 24.0499 17.1423 23.8784C17.1614 23.707 17.1465 23.5335 17.0985 23.3678C17.0504 23.2022 16.9702 23.0476 16.8624 22.9129C16.7546 22.7782 16.6213 22.666 16.4701 22.5828C16.3189 22.4996 16.1527 22.447 15.9812 22.428C15.8097 22.4089 15.636 22.4238 15.4702 22.4718C15.3045 22.5198 15.1498 22.6 15.015 22.7077L9.32919 27.2411L7.49211 25.4359Z",
    fill: "#F2A619",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 24,
      columnNumber: 13
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.5079 8.20518L29.1269 10.1026L28.6445 9.61031C28.3954 9.36277 28.0582 9.22425 27.7069 9.22521C27.3556 9.22617 27.0191 9.36654 26.7714 9.61544C26.5237 9.86433 26.3852 10.2014 26.3861 10.5524C26.3871 10.9034 26.5275 11.2397 26.7766 11.4872L28.0903 12.7795C28.3433 13.0258 28.6813 13.1653 29.0345 13.1693C29.3345 13.1691 29.6251 13.0639 29.8555 12.8718L33.15 10.2565C33.2848 10.1487 33.397 10.0155 33.4802 9.86439C33.5635 9.7133 33.6162 9.5473 33.6352 9.37587C33.6543 9.20444 33.6394 9.03093 33.5914 8.86526C33.5433 8.69959 33.4631 8.545 33.3553 8.41031C33.2475 8.27562 33.1141 8.16347 32.963 8.08027C32.8118 7.99707 32.6456 7.94444 32.4741 7.92539C32.3026 7.90634 32.1289 7.92125 31.9631 7.96925C31.7974 8.01726 31.6427 8.09743 31.5079 8.20518Z",
    fill: "#0D4599",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 28,
      columnNumber: 13
    }
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.5739 0.348764L36.0852 5.47697C36.3656 5.73876 36.5874 6.05688 36.7359 6.41042C36.8845 6.76395 36.9566 7.14491 36.9474 7.52825V15.8154C36.9508 15.9917 36.919 16.1669 36.8538 16.3307C36.7886 16.4945 36.6913 16.6436 36.5676 16.7693C36.4455 16.8963 36.2988 16.9972 36.1365 17.066C35.9742 17.1347 35.7996 17.1699 35.6234 17.1693H23.7489C23.5743 17.1691 23.4015 17.1335 23.241 17.0648C23.0805 16.996 22.9355 16.8955 22.815 16.7693C22.6913 16.6436 22.594 16.4945 22.5288 16.3307C22.4635 16.1669 22.4318 15.9917 22.4352 15.8154V7.49748C22.426 7.11414 22.4981 6.73318 22.6466 6.37965C22.7952 6.02611 23.017 5.70799 23.2974 5.4462L28.7984 0.317992C29.0423 0.0956308 29.3622 -0.0250578 29.6923 -0.0193368C30.0224 -0.0136158 30.3378 0.118084 30.5739 0.348764ZM25.0729 7.52825V14.5334H34.3097V7.49748C34.32 7.4711 34.32 7.44181 34.3097 7.41543L29.7221 3.12825L25.1242 7.41543C25.1004 7.43803 25.0828 7.46625 25.0729 7.49748V7.52825Z",
    fill: "#0D4599",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 32,
      columnNumber: 13
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5263 3.07692L18.4737 1.02563",
    stroke: "#A6E5FF",
    strokeWidth: "2",
    strokeLinecap: "round",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 38,
      columnNumber: 13
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5 7.17944H16.4211",
    stroke: "#A6E5FF",
    strokeWidth: "2",
    strokeLinecap: "round",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 44,
      columnNumber: 13
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.8158 23.5897V20.5128",
    stroke: "#A6E5FF",
    strokeWidth: "2",
    strokeLinecap: "round",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 50,
      columnNumber: 13
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.9737 22.5641L35.9211 20.5128",
    stroke: "#A6E5FF",
    strokeWidth: "2",
    strokeLinecap: "round",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 56,
      columnNumber: 13
    }
  })), /*#__PURE__*/React.createElement("defs", {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 63,
      columnNumber: 9
    }
  }, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 64,
      columnNumber: 13
    }
  }, /*#__PURE__*/React.createElement("rect", {
    width: "39",
    height: "40",
    fill: "white",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 65,
      columnNumber: 17
    }
  }))));
};

ComparableHome.propTypes = process.env.NODE_ENV !== "production" ? {
  className: PropTypes.string
} : {};
ComparableHome.defaultProps = {
  className: null
};
export default ComparableHome;